import api from '@/apis/pa/pAEmployeeHistoryAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('pAEmployeeHistory', api);

const state = {
  ...crud.state,
  _config: {
    table: 'pa_employee_history',
    field: {
      key: 'id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
